import { render, staticRenderFns } from "./EventFinalizeStep.vue?vue&type=template&id=b05e22d0"
import script from "./EventFinalizeStep.vue?vue&type=script&lang=js"
export * from "./EventFinalizeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports